function handleCopyBtn() {
  const copyBtns = document.querySelectorAll(".js-share-link-copy-btn");
  copyBtns.forEach((copyBtn) => {
    const copiedText = copyBtn.querySelector("span");
    copyBtn.addEventListener("click", () => {
      const shareEntryUrl = copyBtn.getAttribute("data-share-entryUrl");
      navigator.clipboard.writeText(shareEntryUrl);
      if (copiedText.classList.contains("hidden")) {
        copiedText.classList.remove("hidden");
      }
      setTimeout(function () {
        copiedText.classList.add("hidden");
      }, 5000);
    });
  });
}

function handleSocialBtn() {
  const socialBtns = document.querySelectorAll(".js-share-link-social-btn");
  socialBtns.forEach((socialBtn) => {
    socialBtn.addEventListener("click", () => {
      const sharer = socialBtn.getAttribute("data-sharer");
      const shareEntryUrl = encodeURIComponent(
        socialBtn.getAttribute("data-share-entryUrl")
      );
      const shareEntryTitle = encodeURIComponent(
        socialBtn.getAttribute("data-share-entryTitle")
      );

      let shareUrl = null;

      switch (sharer) {
        case "facebook":
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareEntryUrl}`;
          break;
        case "twitter":
          shareUrl = `https://twitter.com/intent/tweet?text=${shareEntryTitle}&url=${shareEntryUrl}`;
          break;
        case "linkedin":
          shareUrl = `https://www.linkedin.com/shareArticle?url=${shareEntryUrl}`;
          break;
      }

      if (shareUrl) {
        openSharePopup(shareUrl);
      }
    });
  });
}

function openSharePopup(shareUrl) {
  const popWidth = 600,
    popHeight = 480,
    left = window.innerWidth / 2 - popWidth / 2 + window.screenX,
    top = window.innerHeight / 2 - popHeight / 2 + window.screenY,
    popParams =
      "scrollbars=no, width=" +
      popWidth +
      ", height=" +
      popHeight +
      ", top=" +
      top +
      ", left=" +
      left;

  window.open(shareUrl, "", popParams);
}

function main() {
  handleCopyBtn();
  handleSocialBtn();
}

export default function () {
  main();
}
